import RunbookModel from 'app/views/core/runbooks/RunbookModel';
import { Collection } from 'core/model';

class RunbookCollection extends Collection {
  get model() {
    return RunbookModel;
  }

  get url() {
    return '/api/ui/runbook';
  }

  get defaultSortState() {
    return {
      field: 'name',
      direction: 'desc'
    };
  }

  getRunbooksForResource(resourceType, resourceId) {
    if (!resourceType || !resourceId) {
      return [];
    }

    // assuming given id is valid
    // can be uuid or numeric id
    return this.get().filter((runbook) => {
      const mappings = runbook.getMappingsByType(resourceType);
      return mappings.some(({ resource_id }) => resource_id === resourceId.toString());
    });
  }
}

export default RunbookCollection;
